import * as React from 'react';
import { Spinner } from 'react-bootstrap';
import { formatoDecimal } from '../../../../utilities/formatoNumeros';

export default class NovedadesDeLiquidacionBorrador extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            novedades: props.novedades,
            seleccionarTodo: false
        }
    };

    componentDidUpdate(prevProps) {
        if (prevProps.novedades !== this.props.novedades) {
            let novedadesChecked = this.props.novedades.map(x => ({...x, checked: x.idLiquidacion != 0}));
            this.setState({ novedades: novedadesChecked })
        }
    }

    handleChangeCheckbox = (id) => {
        this.setState((prevState) => {
            const novedades = prevState.novedades.map((novedad) => {
                if (novedad.idNovedad === id) {
                return {
                    ...novedad,
                    checked: !novedad.checked
                };
                }
                return novedad;
            });
            return { novedades };
        });
    };

    handleSelectAllCheckbox(seleccionarTodo) {
        this.setState((prevState) => {
            const novedades = prevState.novedades.map((novedad) => ({
                ...novedad,
                checked: seleccionarTodo
            }));
            return { novedades };
        });

        this.setState({ seleccionarTodo: seleccionarTodo });
    };


    render = () => {

        return (

            this.props.isLoading ?

            <div className="d-flex justify-content-center">
                <Spinner animation="border" variant="secondary" size="lg-centrado" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner>
            </div>

            :

            this.state.novedades.length > 0 ?
                
            <div className="row justify-content-center align-items-center p-10">

                <h5 className="col-auto">Novedades</h5>

                <div className="list-group-item col-12 animated fadeIn">
                    <div className="table-responsive card">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col"><small>Orden Ref</small></th>
                                    <th scope="col"><small>Tipo</small></th>
                                    <th scope="col"><small>Fecha</small></th>
                                    <th scope="col"><small>Importe</small></th>
                                    <th scope="col"><small>Acción</small></th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.novedades.map((novedad, i) => {
                                    return (
                                        <tr key={i} className="hover-background-color">
                                            <td><span><small>{novedad.ordenDeReferencia}</small></span></td>
                                            <td><span><small>{novedad.detalleTipoNovedad}</small></span></td>
                                            <td><span><small>{new Date(novedad.fechaNovedad).toLocaleDateString()}</small></span></td>
                                            <td><small>${formatoDecimal(novedad.importe)}</small></td>
                                            <td><span><small>{novedad.detalleSubTipoNovedad}</small></span></td>
                                        </tr>
                                    )
                                }
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>

            :

            <div className="card">
                <div className="card-body">
                    <div className="row justify-content-center align-items-center p-10">
                        No hay novedades para esta liquidación
                    </div>
                </div>
            </div>

        );
    }
}